import Modal from "react-modal";
import { Trash2, X } from "lucide-react";

const DeleteConfirmationModal = ({
  isOpen,
  onRequestClose,
  onDelete,
  itemName,
  itemType = "item",
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel={`Delete ${itemType} Confirmation`}
      className="bg-white rounded-xl shadow-lg max-w-sm w-full p-4 mx-auto relative outline-none"
      overlayClassName="fixed inset-0 bg-black/[60%] flex justify-center items-center z-50"
    >
      <button
        onClick={onRequestClose}
        className="absolute top-4 right-4 text-gray-500 hover:text-gray-800"
      >
        <X size={22} />
      </button>

      <div className="flex flex-col items-center gap-3 ">
        <Trash2 size={28} className="text-red" />
        <h2 className="text-xl font-bold text-black">Confirm Deletion</h2>
      </div>

      <p className="text-sm text-grey text-center mb-6 leading-relaxed">
        Are you sure you want to delete this {itemType}:{" "}
        <span className="font-semibold text-darkblue">{itemName}</span>? This
        action cannot be undone.
      </p>

      <div className="flex justify-end gap-4">
        <button
          onClick={onDelete}
          className="w-1/2 px-4 py-2 text-sm font-medium rounded-md bg-red text-white hover:bg-red-700 transition"
        >
          Delete
        </button>
        <button
          onClick={onRequestClose}
          className="w-1/2 px-4 py-2 text-sm font-medium rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
        >
          Cancel
        </button>
      </div>
    </Modal>
  );
};

export default DeleteConfirmationModal;
